import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  const URL_EMPRESAS =
    process.env.REACT_APP_URL_EMPRESAS ||
    (process.env.REACT_APP_URL_AREAS || "").replace("areas", "empresas");

  // Un card de Gastos por empresa: /Gastos/:idEmpresa
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setEmpresas(
          (res.data || [])
            .filter((e) => e.is_active !== "No")
            .sort((a, b) => (a.name > b.name ? 1 : -1))
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const items = [
    { type: "section", label: "Registro" },
    ...empresas.map((e) => ({
      label: `Gastos ${e.name}`,
      icon: "fas fa-receipt",
      color: "#f59e0b",
      bg: "#fffbeb",
      href: `/Gastos/${e._id}`,
      desc: `Registro de gastos de ${e.name}`,
      perm: "menu_gastos",
    })),
  ];

  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-wallet" color="#f59e0b" bg="#fffbeb" title="Gastos" subtitle="Administración de gastos y conceptos" />
        {user.menu_admin ? (
          <div className="row">
            {items.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesGastos;
